export default ({app, $gtag}, inject) => {
  function hasConsented() {
    if (window.CookieFirst && window.CookieFirst.consent) {
      const consents = window.CookieFirst.consent;
      return Object.keys(consents).includes('performance');
    }
    return false;
  }

  function gtagConsent() {
    if (!hasConsented()) {
      return;
    }
    $gtag(arguments);
  }

  inject('gtagConsent', gtagConsent);
};
